import { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import { Root } from "./styles";
import { Box } from "@mui/system";

const messages = [
    "Preparing your PDF…",
    "Laying out your menu design…",
    "Formatting dishes and details…",
    "Giving it the chef’s kiss…"
];

export default function LoadingScreen({ printLoading = false }) {
    const [messageIndex, setMessageIndex] = useState(0);
    const [fade, setFade] = useState(true);

    useEffect(() => {
        if (!printLoading) return;

        const interval = setInterval(() => {
            setFade(false);
            setTimeout(() => {
                setMessageIndex((prev) => (prev + 1) % messages.length);
                setFade(true);
            }, 500); // match fade-out duration
        }, 4000);

        return () => clearInterval(interval);
    }, [printLoading]);

    return (
        <Root className={`container ${printLoading ? "printLoading" : ""}`}>
            <CircularProgress className="circularProgress" color="primary" />
            <Box
                className={`loadingText  ${
                    printLoading ? (fade ? "fade-in" : "fade-out") : ""
                }`}
            >
                <Box className="animate-pulse">
                    {" "}
                    {printLoading
                        ? messages[messageIndex]
                        : "Preparing your menu..."}
                </Box>
            </Box>
        </Root>
    );
}
